'use strict';

var gtagApp = function () {
  var UA = true ? 'UA-165926888-1' : 'XXX';
  var CP = void 0,
      dealerName = void 0,
      dealerID = void 0;

  /**
   * Google tag manager instance
   */
  // window.googleDataLayer = window.googleDataLayer || [];
  // function gtag() { googleDataLayer.push(arguments); }
  // gtag('js', new Date());
  // gtag('config', UA);

  /**
   * Initialize events for current page
   * @param {object} params Initial parameters as an object
   */
  var _init = function _init(params) {
    if (params.page === 'home') _home(params.area);
    if (params.page === 'modelo') _modelo(params.area, params.model);
    if (params.page === 'detalle') _detalle(params.area, params.model, params.financial);
    if (params.page === 'peticion') _peticion(params.area, params.model, params.cp);
    if (params.page === 'thankyou') _thankyou(params.type, params.id_lead);
  };

  /**
   * Sets events for home page
   * @param {string} area Regional area defined at home.jsp
   */
  var _home = function _home(area) {
    var areas = document.querySelectorAll('.gtag-area');
    areas.forEach(function (area) {
      area.addEventListener('click', function () {
        // gtag('event', 'click', {
        //   'send_to': UA,
        //   'event_category': 'Seleccionar zona',
        //   'event_label': area.dataset.area
        // })
      });
    });

    document.querySelector('.gtag-faqs').addEventListener('click', function () {
      // gtag('event', 'click', {
      //   'send_to': UA,
      //   'event_category': 'FAQS',
      //   'event_label': ''
      // })
    });

    document.querySelector('.gtag-push').addEventListener('click', function () {
      // gtag('event', 'click', {
      //   'send_to': UA,
      //   'event_category': 'Push home',
      //   'event_label': ''
      // })
    });

    var vehicles = document.querySelectorAll('.gtag-model');
    vehicles.forEach(function (vehicle) {
      vehicle.addEventListener('click', function () {
        // gtag('event', 'click', {
        //   'send_to': UA,
        //   'event_category': 'Seleccionar modelo',
        //   'event_label': area + " / " + this.dataset.model
        // })
      });
    });
  };

  var _modelo = function _modelo(area, model) {

    var filters = document.querySelectorAll('.gtag-filter');
    var filtersText = void 0;

    var _reload = function _reload() {
      filtersText = {};
      filters.forEach(function (filter) {
        filtersText[filter.dataset.category] = filter.dataset.category === 'order' ? filter.options[filter.selectedIndex].text : filter.value;
      });
    };
    _reload();

    filters.forEach(function (filter) {
      filter.addEventListener('change', function () {
        _reload();
        // gtag('event', 'click', {
        //   'send_to': UA,
        //   'event_category': 'Filtro',
        //   'event_label': area + " / " + model + " / " + filtersText.vmotor + " / " + filtersText.vgrado + " / " + filtersText.vtipoTransmision + " / " + filtersText.vtraccion + " / " + filtersText.vcolor + " / " + filtersText.order
        // })
      });
    });

    var requests = document.querySelectorAll('.gtag-request');
    requests.forEach(function (request) {
      if (!request.classList.contains('listen')) {
        request.addEventListener('click', function () {
          // gtag('event', 'click', {
          //   'send_to': UA,
          //   'event_category': 'Haz tu pedido listado',
          //   'event_label': area + " / " + model + " / " + request.dataset.codcom + " / " + request.dataset.pvp + " / " + request.dataset.offer
          // })
          googleDataLayer.push({
            'event': 'cta',
            'eventType': 'purchase',
            'userArea': area,
            'vehicleModel': model,
            'vehicleVersion': request.dataset.version,
            'vehicleID': request.dataset.codcom,
            'vehiclePrice': request.dataset.pvp,
            'vehicleOffer': request.dataset.offer
          });
        });
      }
      request.classList.add('listen');
    });

    var details = document.querySelectorAll('.gtag-details');
    details.forEach(function (detail) {
      if (!detail.classList.contains('listen')) {
        detail.addEventListener('click', function () {
          // gtag('event', 'click', {
          //   'send_to': UA,
          //   'event_category': 'Ver más detalles',
          //   'event_label': area + " / " + model + " / " + detail.dataset.codcom + " / " + detail.dataset.pvp + " / " + detail.dataset.offer
          // })
          googleDataLayer.push({
            'event': 'cta',
            'eventType': 'next_step',
            'userArea': area,
            'vehicleModel': model,
            'vehicleVersion': detail.dataset.version,
            'vehicleID': detail.dataset.codcom,
            'vehiclePrice': detail.dataset.pvp,
            'vehicleOffer': detail.dataset.offer
          });
        });
      }
      detail.classList.add('listen');
    });
  };

  var _detalle = function _detalle(area, model, financial) {
    var requests = document.querySelectorAll('.gtag-request');
    requests.forEach(function (request) {
      if (!request.classList.contains('listen')) {
        request.addEventListener('click', function () {
          // gtag('event', 'click', {
          //   'send_to': UA,
          //   'event_category': 'Siguiente paso',
          //   'event_label': area + " / " + model.vehicle.vmodelo + " / " + model.vcodCom + " / " + model.prices.precioMostrar + " / " + model.prices.precioFinanciacion
          // })

          googleDataLayer.push({
            'event': 'cta',
            'eventType': 'purchase',
            'userArea': area,
            'vehicleModel': model.vehicle.vmodelo,
            'vehicleVersion': model.vehicle.vgrado,
            'vehicleID': model.vcodCom,
            'vehiclePrice': model.prices.precioMostrar,
            'vehicleOffer': model.prices.precioOferta
          });
        });
      }
      request.classList.add('listen');
    });

    if (typeof financial !== 'undefined') {
      // gtag('event', 'click', {
      //   'send_to': UA,
      //   'event_category': 'Cálculo de cuota',
      //   'event_label': area + " / " + model.vehicle.vmodelo + " / " + model.vcodCom + " / " + financial.descripcion + " / " + financial.entrada + " / " + financial.duracion + " / " + financial.s_pc_importe + " / " + financial.s_cv_importe + " / " + model.prices.precioMostrar + " / " + model.prices.precioFinanciacion + " / " + financial.cuota_financiera
      // })
    }
  };

  var _peticion = function _peticion(area, model, cp) {
    if (typeof model === 'undefined') model = globalModel;
    /**
     * Searching by postal code
     * @param {string} cp postal code introduced for search
     */
    var searchCP = function searchCP(postalCode) {
      CP = postalCode;
      // gtag('event', 'click', {
      //   'send_to': UA,
      //   'event_category': 'Dealer search',
      //   'event_label': area + " / " + CP
      // })
      googleDataLayer.push({
        'event': 'dealer',
        'eventType': 'search',
        'userArea': area,
        'dealerPostalCode': CP,
        'vehicleModel': model.vehicle.vmodelo,
        'vehicleVersion': model.vehicle.vgrado,
        'vehicleID': model.vcodCom,
        'vehiclePrice': model.prices.precioMostrar,
        'vehicleOffer': model.prices.precioOferta
      });
    };
    /**
     * Changed for get event when the response is not empty
     */
    if (cp) searchCP(document.querySelector('.gtag-search-input').value);

    /**
     * Old events on click or "Enter"
     */
    // let searchInput = document.querySelector('.gtag-search-input')
    // if (!searchInput.classList.contains('listen')) {
    //   searchInput.addEventListener('keyup', function (e) {
    //     if (e.keyCode === 13 && searchInput.value !== '') {
    //       searchCP(searchInput.value)
    //     }
    //   })
    //   searchInput.classList.add('listen')
    // }
    // let searchBtn = document.querySelector('.gtag-search-btn')
    // if (!searchBtn.classList.contains('listen')) {
    //   searchBtn.addEventListener('click', function () {
    //     searchCP(searchInput.value)
    //   })
    //   searchBtn.classList.add('listen')
    // }

    /**
     * Button than selects a dealer
     */
    var dealerBtn = document.querySelectorAll('.gtag-dealer-btn');
    dealerBtn.forEach(function (dealer) {
      dealer.addEventListener('click', function () {
        console.log('dealer.dataset', dealer.dataset);
        dealerName = dealer.dataset.gtagdealer;
        dealerID = 'pt_nissan_' + dealer.dataset.gtagdealerid.toLowerCase();
        // gtag('event', 'click', {
        //   'send_to': UA,
        //   'event_category': 'Select dealer',
        //   'event_label': area + " / " + CP + " / " + dealerName
        // })
        googleDataLayer.push({
          'event': 'dealer',
          'eventType': 'select',
          'userArea': area,
          'dealerPostalCode': CP,
          'dealerName': dealerName,
          'dealerID': dealerID,
          'vehicleModel': model.vehicle.vmodelo,
          'vehicleVersion': model.vehicle.vgrado,
          'vehicleID': model.vcodCom,
          'vehiclePrice': model.prices.precioMostrar,
          'vehicleOffer': model.prices.precioOferta
        });
      });
    });

    var tabs = document.querySelectorAll('.gtag-tab-form');
    tabs.forEach(function (tab) {
      if (!tab.classList.contains('listen')) {
        tab.addEventListener('click', function () {
          if (!tab.previousElementSibling.checked) {
            // gtag('event', 'click', {
            //   'send_to': UA,
            //   'event_category': 'Toggle',
            //   'event_label': area + " / " + CP + " / " + dealerName + " / " + tab.dataset.gtagform
            // })
            var formInicio = tab.dataset.gtagform === 'Solicita esta oferta' ? 'Solicitud oferta inicio' : 'Reserva Inicio';
            // gtag('event', 'click', {
            //   'send_to': UA,
            //   'event_category': formInicio,
            //   'event_label': area + " / " + CP + " / " + model.vehicle.vmodelo + " / " + model.vcodCom + " / " + dealerName + " / " + model.prices.precioMostrar + " / " + model.prices.precioFinanciacion
            // })
          }
        });
        tab.classList.add('listen');
      }
    });

    var forms = document.querySelectorAll('.gtag-form form');
    forms.forEach(function (form) {
      if (!form.classList.contains('listen')) {
        form.addEventListener('submit', function () {
          // window.sessionStorage.setItem('gtag', area + " / " + CP + " / " + model.vehicle.vmodelo + " / " + model.vcodCom + " / " + dealerName + " / " + model.prices.precioMostrar + " / " + model.prices.precioOferta)
          window.sessionStorage.setItem('gtm', '{ "event": "ask_information", "eventType": "thankyou", "userType": "particular", "userArea": "' + area + '", "dealerPostalCode": "' + CP + '", "dealerName": "' + dealerName + '", "dealerID": "' + dealerID + '", "vehicleModel": "' + model.vehicle.vmodelo + '", "vehicleVersion": "' + model.vehicle.vgrado + '", "vehicleID": "' + model.vcodCom + '", "vehiclePrice": "' + model.prices.precioMostrar + '", "vehicleOffer": "' + model.prices.precioOferta + '", "orderID": "" }');
        });
        form.classList.add('listen');
        var phone = document.querySelector('#formOffer .js-field-phone');
        if (!phone.classList.contains('listen')) {
          phone.addEventListener('click', function () {
            googleDataLayer.push({
              'event': 'ask_information',
              'eventType': 'fiftypercent',
              'userType': 'particular',
              'userArea': area,
              'dealerPostalCode': CP,
              'dealerName': dealerName,
              'dealerID': dealerID,
              'vehicleModel': model.vehicle.vmodelo,
              'vehicleVersion': model.vehicle.vgrado,
              'vehicleID': model.vcodCom,
              'vehiclePrice': model.prices.precioMostrar,
              'vehicleOffer': model.prices.precioOferta
            });
          });
          phone.classList.add('listen');
        }

        var nif = document.querySelector('#formSale .js-field-nif');
        if (!nif.classList.contains('listen')) {
          nif.addEventListener('click', function () {
            googleDataLayer.push({
              'event': 'purchase',
              'eventType': 'fiftypercent',
              'userType': 'particular',
              'userArea': area,
              'dealerPostalCode': CP,
              'dealerName': dealerName,
              'dealerID': dealerID,
              'vehicleModel': model.vehicle.vmodelo,
              'vehicleVersion': model.vehicle.vgrado,
              'vehicleID': model.vcodCom,
              'vehiclePrice': model.prices.precioMostrar,
              'vehicleOffer': model.prices.precioOferta
            });
          });
          nif.classList.add('listen');
        }
      }
    });
  };

  var _thankyou = function _thankyou(type, id_lead) {

    if (window.sessionStorage.getItem('gtag')) {
      console.log('_thankyou');
      window.addEventListener('load', function () {
        console.log('load');
        // gtag('event', 'submit', {
        //   'send_to': UA,
        //   'event_category': (type === 'Pedido') ? 'Reserva fin' : 'Solicitud oferta fin',
        //   'event_label': window.sessionStorage.getItem('gtag') + " / " + id_lead
        // })
        window.sessionStorage.removeItem('gtag');
      });
    }

    if (window.sessionStorage.getItem('gtm')) {
      window.addEventListener('load', function () {
        var data = JSON.parse(window.sessionStorage.getItem('gtm'));
        data.orderID = id_lead;
        data.event = type === 'Pedido' ? 'purchase' : 'ask_information';
        googleDataLayer.push(data);
        window.sessionStorage.removeItem('gtm');
      });
    }
  };

  return {
    init: _init
  };
}();